import '~/validators/configureVine'

export default defineNuxtPlugin({
  name: 'vine-messages-fr',
})

